import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useParams, useNavigate, Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { apiFetch, formatDateForInput } from "api/Api";
import BASE_URL from "api/Api";
import "assets/theme/admin_form.css";

const EditJanataDarbar = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(null);

  const [formData, setFormData] = useState({
    title: "",
    organizer: "",
    date: "",
    start_time: "",
    end_time: "",
    venue: "",
    ward_id: "",
    address: "",
    description: "",
    status: "Scheduled",
    banner: null,
  });

  const loadDarbar = async () => {
    try {
      const res = await apiFetch(`leader_admin/edit_janta_darbar/${id}`);
      const data = res.data;

      setFormData((prev) => ({
        ...prev,
        title: data.title,
        organizer: data.organizer,
        date: formatDateForInput(data.darbar_date),
        start_time: data.start_time,
        end_time: data.end_time,
        venue: data.venue,
        ward_id: data.ward_id,
        address: data.address,
        description: data.description,
        status: data.status,
      }));

      if (data.banner) {
        setPreview(`${BASE_URL}${data.banner}`);
      }
    } catch (error) {
      alert(error.message);
    }
  };

  useEffect(() => {
    loadDarbar();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "banner") {
      setFormData({ ...formData, banner: files[0] });
      setPreview(URL.createObjectURL(files[0]));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = new FormData();
      Object.keys(formData).forEach((key) => {
        if (formData[key] !== null) {
          data.append(key, formData[key]);
        }
      });

      await apiFetch(`leader_admin/update_janta_darbar/${id}`, {
        method: "PUT",
        body: data,
      });

      alert("Darbar updated successfully");
      navigate("/jantadarbar_list");
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>
        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                ✏️ जनता दरबार संपादित करा (Edit Janata Darbar)
              </h4>
              <small className="text-white-50">Update Janata Darbar details and banner</small>
            </div>
          </div>

          <Link to="/jantadarbar_list" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
            Darbar List
          </Link>
        </div>

        <div className="card shadow-lg rounded-4 border-0">
          <div className="card-body p-4">
            <form onSubmit={handleSubmit}>
              <div className="row g-4">
                <div className="col-md-6">
                  <label className="form-label fw-semibold">Darbar Title</label>
                  <input
                    type="text"
                    name="title"
                    className="form-control"
                    value={formData.title}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Organizer</label>
                  <input
                    type="text"
                    name="organizer"
                    className="form-control"
                    value={formData.organizer}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold">Date</label>
                  <input
                    type="date"
                    name="date"
                    className="form-control"
                    value={formData.date}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold">Start Time</label>
                  <input
                    type="time"
                    name="start_time"
                    className="form-control"
                    value={formData.start_time}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold">End Time</label>
                  <input
                    type="time"
                    name="end_time"
                    className="form-control"
                    value={formData.end_time}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Venue</label>
                  <input
                    type="text"
                    name="venue"
                    className="form-control"
                    value={formData.venue}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Status</label>
                  <select
                    name="status"
                    className="form-select"
                    value={formData.status}
                    onChange={handleChange}
                  >
                    <option value="Scheduled">Scheduled</option>
                    <option value="Completed">Completed</option>
                    <option value="Cancelled">Cancelled</option>
                  </select>
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">Address</label>
                  <textarea
                    name="address"
                    className="form-control"
                    value={formData.address}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">Description</label>
                  <textarea
                    name="description"
                    className="form-control"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Change Banner</label>
                  <input type="file" name="banner" className="form-control" onChange={handleChange} />
                </div>

                {preview && (
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Banner Preview</label>
                    <div>
                      <img
                        src={preview}
                        alt="preview"
                        className="img-fluid rounded shadow-sm"
                        style={{ maxHeight: "180px" }}
                      />
                    </div>
                  </div>
                )}
              </div>

              <div className="mt-4 text-end">
                <button className="btn btn-primary px-5" disabled={loading} style={{ fontSize: "0.85rem" }}>
                  {loading ? "Updating..." : "Update Darbar"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default EditJanataDarbar;
